// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";

import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'
import InstallerInstallationWidget from "../../components/Dashboard/InstallerInstallationWidget.js";

var dashboardCommonJS = require("../../js/dashboardCommon.js");
var generalCommonJS = require("../../js/generalCommon.js")
var initialConfigCommonJS = require("../../js/initialConfigCommon.js");

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postInstallerConsultUserInstallation = endpointHelias+'/Helias/V0/General/postInstallerConsultUserInstallation';

const InstallerSharedInstallations = (params) => {    

  useEffect(() => {                 
    console.log("Componente widget instalaciones compartidas cargado correctamente.")      
  }, []);
  
  function abrirCerrarWidget(idInstalacion){
    if(!document.getElementById("details"+idInstalacion).hasAttribute("open")){ //Abro
      dashboardCommonJS.cargarDatosInstalacionCompartidaInstalador(idInstalacion)
    }    
  }

  function consultarInstalacion(e, idCuenta, idInstalacion){
    
    e.stopPropagation()

    generalCommonJS.registrarEventoAnalitica(ReactGA, 'INSTALADOR', 'CONSULTA - Instalación', "", "")
    
    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken") 

    //Actualizo en BBDD el la instalación seleccionada como la última usada
    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", postInstallerConsultUserInstallation, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify({"installerAccountID":localStorage.getItem("accountID"),"installerID":localStorage.getItem("installationId"),"accountID":idCuenta,"installationID":idInstalacion});       
    
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {          

        console.log("Credenciales de consulta de instalador generadas correctamente.")
        
        localStorage.removeItem("lastDashboardData")        
        localStorage.removeItem("lastSmartDevicesStatus")        
        localStorage.removeItem("forceUpdate")
        localStorage.removeItem("updateAccountIDInstallationColdStartHeating")    
        
        //Redirijo a la instalación
        window.location.href = "/"
      }            
      if (this.readyState === 4 && this.status !== 200) {              
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)                   
      }            
    };
    xhttp.send(data); 
              
  }

  const listInstallations = params.objListadoInstalacionesCompartidas.map((installation) =>
  
    <React.Fragment key={installation.INSTALLATION_ID}>
            
            <details id={"details"+installation.INSTALLATION_ID} className="accordion" onClick={() => abrirCerrarWidget(installation.INSTALLATION_ID)} searchdata={installation.InstallationName.toLowerCase()+" "+installation.InstallationOwner.toLowerCase()+" "+installation.OwnerPhoneNumber.toLowerCase()+" "+installation.OwnerEmail.toLowerCase()}>
                <summary className="title" >
                    <ul className="list">                
                        <li className="list-item">
                            <figure className="avatar size-l start-self green">
                              <span id={"iconoInstalacion"+installation.INSTALLATION_ID} className="material-icon">{dashboardCommonJS.obtenerIconoInstalacion(installation.InstallationType)}</span>
                            </figure>
                            
                            <div className="outer-content vertical-horizontal">
                              <div className="content" >
                                  <span id={"nombreInstalacion"+installation.INSTALLATION_ID} className="value">{installation.InstallationName}</span>
                                  <span className="label"><p>{installation.InstallationOwner}</p></span>           
                              </div>                                    

                              <div className="horizontal gap-02">
                                
                                { installation.OwnerPhoneNumber.replaceAll(" ", "") !== "" ?
                                  <a href={"tel://"+installation.OwnerPhoneNumber} className="button tertiary rounded">
                                    <span className="material-icon">phone</span>
                                    <span className="hidden">{installation.OwnerPhoneNumber}</span>   
                                  </a>
                                :
                                  <></>
                                }
                                
                                <a href={"mailto:"+installation.OwnerEmail} className="button tertiary rounded">
                                  <span className="material-icon">email</span>
                                  <span className="hidden">{installation.OwnerEmail}</span>
                                </a>

                                <button className="button tertiary rounded" onClick={(e) => consultarInstalacion(e,installation.ACCOUNT_ID,installation.INSTALLATION_ID)}>
                                  <span className="material-icon">login</span>
                                  <span className="hidden">Acceder</span>
                                </button>

                              </div>

                            </div>
                        </li>                            
                    </ul>
                </summary>          
            
                <div id={"divWidget"+installation.INSTALLATION_ID} className="accordion-content">
                  <InstallerInstallationWidget 
                    installationID={installation.INSTALLATION_ID} 
                    tipoInstalacion={installation.InstallationType} 
                    abrirCerrarWidget={abrirCerrarWidget} 
                    mostrarDetalleWidget={params.mostrarDetalleWidget}                    
                    />
                </div>
              
            </details>     

    </React.Fragment>
    
  );    

  return (      
    <>
      { params.objListadoInstalacionesCompartidas.length > 0 ?

        <>
          <div>
            <div >
              <p className="" style={{paddingBottom: "10px", marginTop:"-10px"}}>Instalaciones compartidas: {params.objListadoInstalacionesCompartidas.length}</p>
              <div id="listadoInstalacionesCompartidas" className="vertical gap-02" >
                {listInstallations}
              </div>          
            </div>
          </div>
          
        </>

        :
        <div id="divSinResultadosInstaladores" className="message medium empty">
          <picture>
            <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
            <img src={imgNoResultsDark} alt=""/>
          </picture>
          <h1 className="title">No tienes instalaciones compartidas</h1>
        </div>
      }

    </>  
    )
  }

export default InstallerSharedInstallations